module.exports = __webpack_public_path__ + "static/media/page-under-dev.430ea93f.png";